//This import should point to uicore/constants, because the E2E tests break, due to importing the whole uicore library in. place which can't read the .tsx format
import { ONE_SECOND } from '@lucidlink/uicore/constants';
export const RefetchIntervals = {
    xs: ONE_SECOND,
    s: 5 * ONE_SECOND,
    m: 10 * ONE_SECOND,
    l: 15 * ONE_SECOND,
    xl: 20 * ONE_SECOND,
    xxl: 60 * ONE_SECOND,
};
export const DEFAULT_STALE_INTERVAL = 20 * ONE_SECOND;
export const WORKSPACE_REFETCH_INTERVAL = RefetchIntervals.xxl;
export const FILESPACE_LIST_REFETCH_INTERVAL = RefetchIntervals.l;
